// removed by extract-text-webpack-plugin
module.exports = {"notificationsMenu":"_3LgQaQ7ELRUTx6W8IsWrC3"};


//////////////////
// WEBPACK FOOTER
// ./src/utils/Notifications.less
// module id = 616
// module chunks = 0